import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Time, DatePipe } from '@angular/common';
import { isUndefined } from 'util';

@Component({
  selector: 'app-change-date',
  templateUrl: './change-date.component.html',
  styleUrls: ['./change-date.component.css']
})
export class ChangeDateComponent implements OnInit {
  showChangeEstimatedStartDate: boolean;
  orderEstimatedStartDate: Date;
  orderEstimatedStartTime: Time;
  date = new FormControl(new Date());
  time = new FormControl();
  private hourChanged: boolean;
  actionType = 'CAMBIAR';

  @Input() inputDate: Date;
  @Output() outputDateEvent = new EventEmitter<Date>();

  constructor() { }

  ngOnInit() {
    this.showChangeEstimatedStartDate = false;
    this.orderEstimatedStartDate = this.inputDate;
    this.orderEstimatedStartTime = {
      hours: 2,
      minutes: 2,
    };
    this.orderEstimatedStartTime.hours = 12;
    this.orderEstimatedStartTime.minutes = 0;
    this.date = new FormControl(this.orderEstimatedStartDate);
    this.time = new FormControl(this.orderEstimatedStartTime);
    this.hourChanged = false;

  }

  public changeEstimatedStartDate() {
    if (this.showChangeEstimatedStartDate) { this.showChangeEstimatedStartDate = false; } else { this.showChangeEstimatedStartDate = true; }
  }

  public getEstimatedStartDate(event: MatDatepickerInputEvent<Date>) {
    this.orderEstimatedStartDate = event.value;
    if (this.hourChanged) { this.getEstimatedStartTime(); }
    this.date = new FormControl(this.orderEstimatedStartDate);
  }

  public getEstimatedStartTime() {
    const hourStr = this.time.value.substring(0, 2);
    const minuteStr = this.time.value.substring(3, 5);
    const hour = Number(hourStr);
    const minutes = Number(minuteStr);
    if (isUndefined(this.orderEstimatedStartDate)) {
      this.orderEstimatedStartDate = new Date();
    }
    this.orderEstimatedStartDate.setHours(hour);
    this.orderEstimatedStartDate.setMinutes(minutes);
    this.hourChanged = true;
  }

  public cancel() {
    this.orderEstimatedStartDate = this.inputDate;
    if (!isUndefined(this.orderEstimatedStartDate) && this.orderEstimatedStartDate !== null) {
      this.orderEstimatedStartTime.hours = this.orderEstimatedStartDate.getHours();
      this.orderEstimatedStartTime.minutes = this.orderEstimatedStartDate.getMinutes();
    }
    this.time = new FormControl(this.orderEstimatedStartTime);
    this.date = new FormControl(this.orderEstimatedStartDate);
    this.changeEstimatedStartDate();
  }

  public change() {
    this.inputDate = this.orderEstimatedStartDate;
    this.changeEstimatedStartDate();
    this.emitOutputDate();
  }

  public now() {
    this.orderEstimatedStartDate = new Date();
    this.inputDate = this.orderEstimatedStartDate;
    this.time = new FormControl(this.orderEstimatedStartTime);
    this.date = new FormControl(this.orderEstimatedStartDate);
    this.changeEstimatedStartDate();
    this.emitOutputDate();

  }
  public in24h() {
    this.orderEstimatedStartDate = new Date();
    const aux = this.orderEstimatedStartDate.getDate();
    this.orderEstimatedStartDate.setDate(aux + 1);
    this.inputDate = this.orderEstimatedStartDate;
    this.changeEstimatedStartDate();
    this.time = new FormControl(this.orderEstimatedStartTime);
    this.date = new FormControl(this.orderEstimatedStartDate);
    this.emitOutputDate();
  }

  public removeDate() {
    this.orderEstimatedStartDate = null;
    this.inputDate = this.orderEstimatedStartDate;
    this.changeEstimatedStartDate();
    this.time = new FormControl(null);
    this.date = new FormControl(null);
    this.emitOutputDate();
  }

  private emitOutputDate() {
    this.outputDateEvent.emit(this.inputDate);
  }
}
